document.addEventListener("DOMContentLoaded", () => {
  customElements.whenDefined("media-gallery").then(() => {
    document.querySelectorAll("media-gallery").forEach((gallery) => {
      if (typeof gallery.setActiveMedia !== "function") return;

      const original = gallery.setActiveMedia.bind(gallery);
      gallery.setActiveMedia = (mediaId, prepend) => {
        // Never let it reorder
        const result = original(mediaId, false);

        // Mark active thumbnail and scroll it into view
        const thumb = gallery.querySelector(`[data-target="${mediaId}"]`);
        if (thumb && typeof gallery.setActiveThumbnail === "function") {
          gallery.setActiveThumbnail(thumb);
        }

        const thumbsContainer = gallery.querySelector('[id^="GalleryThumbnails"]');
        if (thumbsContainer && thumb) {
          const isHorizontal = thumbsContainer.scrollWidth > thumbsContainer.clientWidth;
          const targetPos = isHorizontal
            ? thumb.offsetLeft - thumbsContainer.clientWidth / 2 + thumb.clientWidth / 2
            : thumb.offsetTop  - thumbsContainer.clientHeight / 2 + thumb.clientHeight / 2;

          thumbsContainer.scrollTo({
            [isHorizontal ? "left" : "top"]: Math.max(0, targetPos),
            behavior: "smooth"
          });
        } else if (thumb) {
          thumb.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        }

        return result;
      };
    });
  });
});
